import React, { Component } from 'react';

class IconChatMessageEmpty extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="106"
                height="125"
                fill="none"
                viewBox="0 0 106 125"
            >
                <g clipPath="url(#clip0_101_19)">
                    <path
                        fill="#E6EEF5"
                        fillRule="evenodd"
                        d="M60.379 12.276c14.2.687 30.33-15.174 40.658-5.47 10.273 9.653-3.7 26.339-3.504 40.383.203 14.475 12.95 29.62 4.652 41.522-8.573 12.293-26.754 11.388-41.806 11.761-15.59.387-32.377.751-43.946-9.636-11.97-10.747-15.24-27.621-15.4-43.647-.161-16.216.471-36.258 14.52-44.522 13.672-8.044 28.954 8.84 44.826 9.609z"
                        clipRule="evenodd"
                    ></path>
                </g>
                <path
                    fill="#26A"
                    d="M27 101.465V89.257v-16.41c0-5.413 4.407-9.818 9.794-9.818C50.245 63 63.726 63 77.178 63c5.415 0 9.793 4.405 9.822 9.789 0 9.817 0 19.606-.029 29.395a9.811 9.811 0 01-.518 3.138c-1.383 4.06-5.07 6.68-9.448 6.68H41.892c-.26 0-.375.057-.547.201-2.967 2.995-5.963 5.989-8.959 8.983l-.806.806c-.663.662-1.354 1.008-2.045 1.008-.346 0-.663-.086-1.008-.23-1.009-.461-1.527-1.354-1.527-2.649v-18.656zm5.098 9.328v3.483l.98-.978c1.786-1.785 3.6-3.599 5.386-5.413.663-.662 1.44-.979 2.391-.979h35.948c2.218 0 3.687-.893 4.551-2.706.317-.663.49-1.469.49-2.217.029-9.357.029-18.743.029-28.1v-.835c0-2.39-1.325-4.117-3.63-4.78a5.046 5.046 0 00-1.382-.172H37.08c-2.419 0-4.176 1.324-4.839 3.628-.115.374-.172.834-.172 1.324.028 12.582.028 25.163.028 37.745z"
                ></path>
                <path
                    fill="#26A"
                    d="M69.83 83.126c2.391.029 4.35 1.986 4.35 4.376 0 1.152-.461 2.275-1.297 3.11a4.342 4.342 0 01-3.082 1.295h-.028c-2.391-.029-4.35-1.986-4.35-4.376 0-1.152.461-2.275 1.296-3.11.836-.834 1.873-1.295 3.111-1.295zM56.989 83.126c2.39 0 4.378 1.958 4.378 4.347a4.376 4.376 0 01-4.378 4.405c-2.39 0-4.35-1.957-4.378-4.347 0-1.152.432-2.275 1.267-3.11.864-.834 1.959-1.295 3.11-1.295zM44.196 83.126c2.42 0 4.378 1.958 4.378 4.347 0 1.152-.46 2.275-1.296 3.11a4.342 4.342 0 01-3.082 1.295h-.029a4.363 4.363 0 01-4.35-4.347c0-1.152.462-2.275 1.297-3.11a4.342 4.342 0 013.082-1.295z"
                ></path>
                <defs>
                    <clipPath id="clip0_101_19">
                        <path
                            fill="#fff"
                            d="M0 0H105V101H0z"
                            transform="translate(.5 .5)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconChatMessageEmpty;